// src/components/ServiceWorkerUpdate.jsx - RESTORED & IMPROVED
import { useEffect, useRef, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import toast from 'react-hot-toast';

const ToastContent = ({ onUpdate, onClose }) => {
  const [loading, setLoading] = useState(false);

  const handleReload = () => {
    setLoading(true);
    onUpdate();
  };

  return (
    <div className="flex flex-col items-start gap-2 max-w-[300px]">
      <span className="font-semibold text-gray-800">New version available!</span>
      <span className="text-sm text-gray-600">
        A new version of GigShip is available. Click reload to update.
      </span>
      <div className="flex items-center gap-2 mt-2 w-full">
        <button
          onClick={handleReload}
          disabled={loading}
          className="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white px-3 py-1.5 rounded text-sm font-medium transition-colors w-full"
        >
          {loading ? 'Updating...' : 'Reload'}
        </button>
        <button
          onClick={onClose}
          disabled={loading}
          className="bg-gray-100 hover:bg-gray-200 disabled:opacity-50 text-gray-700 px-3 py-1.5 rounded text-sm font-medium transition-colors w-full"
        >
          Later
        </button>
      </div>
    </div>
  );
};

const ServiceWorkerUpdate = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('✅ SW Registered:', r);
    },
    onRegisterError(error) {
      console.log('❌ SW Registration Error:', error);
    },
  });

  const toastShownRef = useRef(false);

  useEffect(() => {
    // Only register listener securely
    const handleControllerChange = () => {
      // Allow browser to handle it natively next load or prompt user
      console.log('SW Controller Changed, ready to reload');
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    }

    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      }
    };
  }, []);

  useEffect(() => {
    if (needRefresh && !toastShownRef.current) {
      toastShownRef.current = true;
      // Regardless of device, let user decide to reload ensuring we don't start infinite loop 
      // where vite-plugin-pwa continually triggers needRefresh.
      toast(
        (t) => (
          <ToastContent
            onUpdate={() => {
              setNeedRefresh(false);
              toast.dismiss(t.id);
              updateServiceWorker(true);
            }}
            onClose={() => toast.dismiss(t.id)}
          />
        ),
        {
          duration: 20000, // Show for 20 seconds
          position: 'bottom-right',
          style: {
            background: '#fff',
            color: '#333',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            border: '1px solid #e5e7eb',
            padding: '12px',
          },
        }
      );
    }
  }, [needRefresh, updateServiceWorker, setNeedRefresh]);

  return null;
};

export default ServiceWorkerUpdate;